import React from 'react'
import './Header.scss'

export default function Header() {
    return (
        <div className='header'>
            <h1>JEU DES PAIRES</h1>
        </div>
    )
}
